import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { IddleComponent } from '../components/IddleComponent';
import { Dashboard } from '../layout/Dashboard';
import { Agenda, Appointment, Appointments } from '../pages/Agenda';
import { Appliance, Appliances } from '../pages/Appliances';
import { AssortmentOrder, AssortmentOrders } from '../pages/AssortmentOrder';
import { BranchAppliance, BranchAppliances } from '../pages/BranchAppliances';
import { Cabain } from '../pages/Cabain/Cabain';
import { Cabains } from '../pages/Cabain/Cabains';
import { CabainType } from '../pages/CabainType/CabainType';
import { CabainTypes } from '../pages/CabainType/CabainTypes';
import { Categories } from '../pages/Categories/Categories';
import { Category } from '../pages/Categories/Category';
import { ConsignOrder, ConsignOrders } from '../pages/ConsignOrder';
import {
  ConsignOrderBilling,
  ConsignOrderBillings,
} from '../pages/ConsignOrderBilling';
import { ConsignOrderRefund } from '../pages/ConsignOrderRefund/ConsignOrderRefund';
import { CosmetologyCommission } from '../pages/CosmetologyCommissions';
import { Coupon, Coupons } from '../pages/Coupons';
import { Customer, Customers } from '../pages/Customer';
import { DailyCashClosing } from '../pages/DailyCashClosing/DailyCashClosing';
import { DailyCashClosingCash } from '../pages/DailyCashClosing/DailyCashClosingCash';
import { Diary } from '../pages/Diary';
import { ForgotPassword } from '../pages/ForgotPassword/ForgotPassword';
import { Fortnightly, FortnightlyRows } from '../pages/Fortnightly';
import { Goal, Goals } from '../pages/Goal';
import { History } from '../pages/History';
import { Lock } from '../pages/Lock';
import { Login } from '../pages/Login/Login';
import { Loyalty } from '../pages/Loyalty';
import { MedicalCommission } from '../pages/MedicalCommissions';
import { Members } from '../pages/Members';
import { Package, Packages } from '../pages/Package';
import { Reorder } from '../pages/ProductOrder/Reorder';
import { ReorderList } from '../pages/ProductOrder/ReorderLIst';
import { Product, Products } from '../pages/Products';
import { ProductType } from '../pages/ProductType';
import { Promotion, Promotions } from '../pages/Promotion';
import { Provider, Providers } from '../pages/Providers';
import { PurchaseOrder, PurchaseOrders } from '../pages/PurchaseOrder';
import { QuickLogin } from '../pages/QuickLogin/QuickLogin';
import { Reports } from '../pages/Reports/Reports';
import { SaleOrder, SaleOrders } from '../pages/SaleOrder';
import { AppSales, BranchSales, CashSales, OnlineSales } from '../pages/Sales';
import { Setting, Settings } from '../pages/Settings';
import { Stock } from '../pages/Stock/stock';
import { Subsidiaries, Subsidiary } from '../pages/Subsidiary';
import { SystemHistory } from '../pages/SystemHistory';
import { Transfer, Transfers } from '../pages/Transfer';
import { Treatment, Treatments } from '../pages/Treatments';
import { User, Users } from '../pages/Users';
import { WeMissYou } from '../pages/WeMissYou/WeMissYou';
import { ConsignOrderRefunds } from '../pages/ConsignOrderRefund/ConsignOrderRefunds';
import { FreezeScreen } from '../components/FreezerScreen';

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/quick-login" element={<QuickLogin />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-password/:code" element={<ForgotPassword />} />

        <Route path="/dashboard" element={<Dashboard />}>
          {/* Personal  */}
          <Route path="/dashboard/personal/:id" element={<User />} />
          <Route path="/dashboard/personal/crear" element={<User />} />
          <Route path="/dashboard/personal" element={<Users />} />

          {/* Categorias */}
          <Route path="/dashboard/categorias/:id" element={<Category />} />
          <Route path="/dashboard/categorias/crear" element={<Category />} />
          <Route path="/dashboard/categorias" element={<Categories />} />

          {/* Aparatos */}
          <Route path="/dashboard/aparatos/:id" element={<Appliance />} />
          <Route path="/dashboard/aparatos/crear" element={<Appliance />} />
          <Route path="/dashboard/aparatos" element={<Appliances />} />

          {/* Branch Aparatos */}
          <Route
            path="/dashboard/aparatos-sucursal/:id"
            element={<BranchAppliance />}
          />
          <Route
            path="/dashboard/aparatos-sucursal/vincular"
            element={<BranchAppliance />}
          />
          <Route
            path="/dashboard/aparatos-sucursal"
            element={<BranchAppliances />}
          />

          {/* Sucursales */}
          <Route path="/dashboard/sucursales/:id" element={<Subsidiary />} />
          <Route path="/dashboard/sucursales/crear" element={<Subsidiary />} />
          <Route path="/dashboard/sucursales" element={<Subsidiaries />} />

          {/* Productos  */}
          <Route path="/dashboard/productos/:id" element={<Product />} />
          <Route path="/dashboard/productos/crear" element={<Product />} />
          <Route path="/dashboard/productos" element={<Products />} />

          {/* Tipo de Productos  */}
          <Route path="/dashboard/tipos-producto" element={<ProductType />} />

          {/* Cabinas */}
          <Route path="/dashboard/cabinas/:id" element={<Cabain />} />
          <Route path="/dashboard/cabinas/crear" element={<Cabain />} />
          <Route path="/dashboard/cabinas" element={<Cabains />} />

          {/* Tipo de Cabinas */}
          <Route path="/dashboard/tipos-cabina/:id" element={<CabainType />} />
          <Route
            path="/dashboard/tipos-cabina/crear"
            element={<CabainType />}
          />
          <Route path="/dashboard/tipos-cabina" element={<CabainTypes />} />

          {/* Product Reorder */}
          <Route path="/dashboard/resurtidos/:id" element={<Reorder />} />
          <Route path="/dashboard/resurtidos/crear" element={<Reorder />} />
          <Route path="/dashboard/resurtidos" element={<ReorderList />} />

          {/* Sale Order  */}
          <Route
            path="/dashboard/ordenes-de-venta/:id"
            element={<SaleOrder />}
          />
          <Route
            path="/dashboard/ordenes-de-venta/crear"
            element={<SaleOrder />}
          />
          <Route path="/dashboard/ordenes-de-venta" element={<SaleOrders />} />

          {/* Treatment */}
          <Route path="/dashboard/tratamientos/:id" element={<Treatment />} />
          <Route path="/dashboard/tratamientos/crear" element={<Treatment />} />
          <Route path="/dashboard/tratamientos" element={<Treatments />} />

          {/* Purchase Order */}
          <Route
            path="/dashboard/ordenes-de-compra/:id"
            element={<PurchaseOrder />}
          />
          <Route
            path="/dashboard/ordenes-de-compra/crear"
            element={<PurchaseOrder />}
          />
          <Route
            path="/dashboard/ordenes-de-compra"
            element={<PurchaseOrders />}
          />

          {/* Providers  */}
          <Route path="/dashboard/proveedores/:id" element={<Provider />} />
          <Route path="/dashboard/proveedores/crear" element={<Provider />} />
          <Route path="/dashboard/proveedores" element={<Providers />} />

          {/* Assortment Order  */}
          <Route
            path="/dashboard/ordenes-de-surtido/:id"
            element={<AssortmentOrder />}
          />
          <Route
            path="/dashboard/ordenes-de-surtido/crear"
            element={<AssortmentOrder />}
          />
          <Route
            path="/dashboard/ordenes-de-surtido"
            element={<AssortmentOrders />}
          />

          {/* Consigna */}
          <Route
            path="/dashboard/ordenes-de-consigna/:id"
            element={<ConsignOrder />}
          />
          <Route
            path="/dashboard/ordenes-de-consigna/crear"
            element={<ConsignOrder />}
          />
          <Route
            path="/dashboard/ordenes-de-consigna"
            element={<ConsignOrders />}
          />

          {/* Factura Consigna */}
          <Route
            path="/dashboard/factura-de-consigna/:id/:numberOrder"
            element={<ConsignOrderBilling />}
          />
          <Route
            path="/dashboard/factura-de-consigna/:id/:numberOrder/crear"
            element={<ConsignOrderBillings />}
          />
          <Route
            path="/dashboard/factura-de-consigna/:id/:numberOrder/:consignmentOrderBillingId"
            element={<ConsignOrderBillings />}
          />

          {/* Devolucion de orden */}

          <Route
            path="/dashboard/devolucion-de-consigna/:id/:numberOrder"
            element={<ConsignOrderRefund />}
          />
          <Route
            path="/dashboard/devolucion-de-consigna/:id/:numberOrder/crear"
            element={<ConsignOrderRefunds />}
          />
          <Route
            path="/dashboard/devolucion-de-consigna/:id/:numberOrder/:consignmentOrderRefundId"
            element={<ConsignOrderRefunds />}
          />

          {/* Transfers */}
          <Route path="/dashboard/transferencias/:id" element={<Transfer />} />
          <Route
            path="/dashboard/transferencias/crear"
            element={<Transfer />}
          />
          <Route path="/dashboard/transferencias" element={<Transfers />} />

          <Route path="/dashboard/inventario" element={<Stock />} />

          {/* History */}
          <Route path="/dashboard/historial" element={<History />} />

          {/* System History */}
          <Route
            path="/dashboard/historial-del-sistema"
            element={<SystemHistory />}
          />

          {/* Dairy */}
          <Route path="/dashboard/bitacora" element={<Diary />} />

          {/* Customers  */}
          <Route path="/dashboard/clientes/:id" element={<Customer />} />
          <Route path="/dashboard/clientes/crear" element={<Customer />} />
          <Route path="/dashboard/clientes" element={<Customers />} />

          {/* Agenda */}
          <Route path="/dashboard/agenda" element={<Agenda />} />
          <Route path="/dashboard/agenda/:id" element={<Appointment />} />
          <Route path="/dashboard/agenda/crear/" element={<Appointment />} />

          {/* Appointments */}
          <Route path="/dashboard/citas" element={<Appointments />} />

          {/* Packages  */}
          <Route path="/dashboard/paquetes/:id" element={<Package />} />
          <Route path="/dashboard/paquetes/crear" element={<Package />} />
          <Route path="/dashboard/paquetes" element={<Packages />} />

          {/* dailyCashClosing  */}
          <Route
            path="/dashboard/corte-sucursal"
            element={<DailyCashClosing />}
          />
          <Route
            path="/dashboard/corte-de-productos"
            element={<DailyCashClosingCash />}
          />

          {/* Sales  */}
          <Route
            path="/dashboard/ventas-sucursal-producto"
            element={<CashSales />}
          />
          <Route path="/dashboard/ventas-en-linea" element={<OnlineSales />} />
          <Route path="/dashboard/ventas-en-app" element={<AppSales />} />
          <Route
            path="/dashboard/ventas-en-sucursal"
            element={<BranchSales />}
          />

          {/* Commission  */}
          <Route
            path="/dashboard/comisiones-cosmetologicas"
            element={<CosmetologyCommission />}
          />
          <Route
            path="/dashboard/comisiones-medicas"
            element={<MedicalCommission />}
          />

          {/* Promotions  */}
          <Route path="/dashboard/promociones/:id" element={<Promotion />} />
          <Route path="/dashboard/promociones/crear" element={<Promotion />} />
          <Route path="/dashboard/promociones" element={<Promotions />} />

          {/* WeMissYou */}
          <Route path="/dashboard/we-miss-you" element={<WeMissYou />} />

          {/* Members */}
          <Route path="/dashboard/miembros" element={<Members />} />
          {/* Locks */}
          <Route path="/dashboard/bloqueos/:id" element={<Lock />} />
          <Route path="/dashboard/bloqueos/crear" element={<Lock />} />
          {/* <Route path='/dashboard/bloqueos/:userId' element={} /> */}

          {/* Loyalty */}
          <Route path="/dashboard/sistema-de-lealtad" element={<Loyalty />} />

          {/* Settings */}
          <Route path="/dashboard/configuraciones" element={<Settings />} />
          <Route
            path="/dashboard/configuraciones/editar/"
            element={<Setting />}
          />

          {/* Coupons */}
          <Route path="/dashboard/cupones/:id" element={<Coupon />} />
          <Route path="/dashboard/cupones/crear" element={<Coupon />} />
          <Route path="/dashboard/cupones" element={<Coupons />} />

          {/* Reports */}
          <Route path="/dashboard/reportes" element={<Reports />} />

          {/* Goals */}
          <Route path="/dashboard/metas/:id" element={<Goal />} />
          <Route path="/dashboard/metas/crear" element={<Goal />} />
          <Route path="/dashboard/metas" element={<Goals />} />
          {/* Fortnightlys */}
          <Route path="/dashboard/catorcenas/crear" element={<Fortnightly />} />
          <Route path="/dashboard/catorcenas" element={<FortnightlyRows />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
      <IddleComponent />
      <FreezeScreen />
    </BrowserRouter>
  );
};

export default Router;
